import { Component } from '@angular/core';
import { ICON } from '@core/util/icon';
import { TITLE_SEARCH_MATTER_STATE } from '@models/matter';
import { SavedWrit } from '@models/teranet';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Select } from '@ngxs/store';
import { MatterDispatch } from '@state/matter';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { SaleWritState } from '@state/sale_writ';
import { Observable } from 'rxjs';

@Component({
	selector: 'app-requisition',
	templateUrl: './requisition.component.html',
	styleUrls: ['./requisition.component.scss'],
	standalone: false,
})
export class TeranetStepperRequisitionComponent {
	@SelectSnapshot(SelectedMatter.id) matterId: string;
	@Select(SaleWritState.hasSavedWrits) hasSavedWrits$!: Observable<SavedWrit[]>;

	ICON = ICON;

	constructor(private matterDispatch: MatterDispatch) {}

	next = (): void => {
		this.matterDispatch.SetTitleState(
			this.matterId,
			TITLE_SEARCH_MATTER_STATE.COMPLETE,
		);
	};

	back = (): void => {
		this.matterDispatch.SetTitleState(
			this.matterId,
			TITLE_SEARCH_MATTER_STATE.WRITS,
		);
	};
}
